import { CalendarIcon } from '@calendly/ui/components/icons'
import { DetailsItem as Item } from '@calendly/booking-kit'

import { useI18n } from 'locales'

const PackageSession = ({ currentSession, numSessions }) => {
  const { i18n } = useI18n()

  return currentSession && numSessions && (
    <Item>
      <div>
        <CalendarIcon size="large" spacingRight={8} data-id="details-item-icon" />
      </div>
      {i18n.t('booking.package.session_of', { current: currentSession, total: numSessions })}
    </Item>
  )
}

export default PackageSession
